"use client"

import { useEffect, useState } from "react"

/**
 * Words cycle through creative opportunity types, then land on "residency".
 * Starts with "residency" (correct SSR / no-JS fallback), explores the
 * full breadth of creative spaces, and comes home.
 */
const words = [
  "residency",     // shown first (idle) — the expected text
  "fellowship",
  "grant",
  "workshop",
  "retreat",
  "commune",
  "collective",
  "lab",
  "incubator",
  "think tank",
  "symposium",
  "festival",
  "biennale",
  "exchange",
  "expedition",
  "pilgrimage",
  "sabbatical",
  "sanctuary",
  "residency",     // lands back home
]

const CYCLE_MS = 1200     // duration of each rolodex flip (matches CSS)
const INITIAL_DELAY = 1200 // let the h1 fade-in-up settle before cycling

export function RotatingText() {
  const [index, setIndex] = useState(0)
  const [started, setStarted] = useState(false)
  const finalIndex = words.length - 1

  // Pause before the rolodex starts spinning
  useEffect(() => {
    const timer = setTimeout(() => {
      setStarted(true)
      setIndex(1) // advance past the idle word
    }, INITIAL_DELAY)
    return () => clearTimeout(timer)
  }, [])

  // Cycle through remaining words
  useEffect(() => {
    if (!started || index >= finalIndex) return
    const timer = setTimeout(() => setIndex((i) => i + 1), CYCLE_MS)
    return () => clearTimeout(timer)
  }, [started, index, finalIndex])

  const isLanded = started && index >= finalIndex

  return (
    <span className="rotating-text-wrapper">
      <span
        key={started ? `w${index}` : "idle"}
        className={
          !started
            ? "rotating-text-idle"
            : isLanded
              ? "rotating-text-landed"
              : "rotating-text-roll"
        }
      >
        {words[index]}
      </span>
    </span>
  )
}
